import { motion } from "framer-motion";

const EASE = [0.22, 0.61, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "0px 0px -40px 0px" }}
    transition={{ duration: 0.75, delay: delay / 1000, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label }) => (
  <div data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`} className="mb-7 flex items-center gap-4">
    <span className="font-display text-sm italic tracking-wide text-teal">{number}</span>
    <span className="h-px w-12 bg-teal/40" aria-hidden="true" />
    <span className="text-xs font-semibold uppercase tracking-[0.22em] text-ink/50">
      {label}
    </span>
  </div>
);
